module.exports = __webpack_public_path__ + "static/media/manjula.82228011.png";